import { h } from "preact";
import { Layout } from 'antd';
import Sidebar from '../side-bar';
import { useState } from 'preact/hooks';
import { Default, Mobile } from '../../../utils/query';
import NavbarHamburger from '../nav-bar';
import LayoutHeader from '../header';
import { useSelector } from "react-redux";

const LayoutSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const isLoading = useSelector((state: IAuthState) => state.auth.loading);
  const isLoadingMenu = useSelector((state: IAuthState) => state.menu.loading);

  if (isLoading || isLoadingMenu) {
    return <div />;
  }

  return (
    <Layout>
      <LayoutHeader />
      <Mobile key={'MOBILE'}>
        <NavbarHamburger collapsed={collapsed} onCollapse={(c: boolean) => setCollapsed(c)} />
      </Mobile>
      <Default>
        <Sidebar collapsed={collapsed} onCollapse={c => setCollapsed(c)} />
      </Default>
    </Layout>
  )
}

export default LayoutSidebar;